import { LayoutModule } from '@angular/cdk/layout';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatBadgeModule } from '@angular/material/badge';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OscUtilsModule } from '@osc-utils/osc-utils.module';
import { AboutModalComponent } from './components/about-modal/about-modal.component';
import { DialogService } from './services/dialog.service';

@NgModule({
  exports: [
    AboutModalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    LayoutModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatSidenavModule,
    MatToolbarModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatListModule,
    MatSelectModule,
    MatGridListModule,
    MatCheckboxModule,
    MatDialogModule,
    MatSlideToggleModule,
    ScrollingModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatCardModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatExpansionModule,
    OscUtilsModule,
    TranslateModule.forChild(),
    AboutModalComponent,
  ],
  providers: [
    DialogService,
  ],
})
export class OscReferenceAppCommonModule {
  public static forRoot(): ModuleWithProviders<OscReferenceAppCommonModule> {
    return {
      ngModule: OscReferenceAppCommonModule,
    };
  }
}
